// src/components/MediaArticleCard.js
import React from "react";

export default function MediaArticleCard({ article }) {
  return (
    <article className="flex flex-col bg-slate-900/80 border border-slate-800 rounded-2xl overflow-hidden shadow-sm shadow-emerald-500/10 hover:-translate-y-0.5 hover:shadow-emerald-500/20 transition-transform">
      {/* Image */}
      {article.image && (
        <div className="aspect-[16/9] overflow-hidden bg-slate-800">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}

      {/* Content */}
      <div className="flex flex-col flex-1 p-4 gap-3">
        <div className="flex items-center justify-between gap-2 text-xs text-slate-400">
          <span className="font-medium uppercase tracking-wide text-emerald-400/90">
            {article.outlet}
          </span>
          {article.date && <span>{article.date}</span>}
        </div>

        <h2 className="text-lg font-semibold text-slate-50 leading-snug">
          {article.title}
        </h2>

        <p className="text-sm text-slate-300 line-clamp-3">
          {article.description}
        </p>

        <div className="mt-auto pt-2">
          <a
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-medium text-emerald-400 hover:text-emerald-300"
          >
            Read article
            <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </article>
  );
}
